
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { ControladorChatActivo } from '@view/a-chat-2/pc/lista/sala/controlador';
    import { Mensaje } from '@/__env/lib/MercadoLibre/Chats/Mensajes';
    import JQuery from 'jquery';
    import { Adjunto } from '@/__env/lib/MercadoLibre/Chats/Mensajes/Mensaje.lib';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;
        @Prop() public Mensaje: Mensaje;
        @Prop() public Archivo: Adjunto;


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {

        }



        DescagarAdjunto()
        {
            window.open( this.Archivo.Archivo );
        }


        SubirDeclararionIIBB()
        {
            this.Controlador.ControladorBarrasLaterales.ArchivoSeleccionado = this.Archivo.URL;
            this.Controlador.ControladorBarrasLaterales.ModoDeArchivoSeleccionado = 'declaracion_iibb';
            this.Controlador.ControladorBarrasLaterales.Vista.Modo  = 'pedidos';
        }

        public Refresh: boolean = true;
        public Recargar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
